import { Component, OnInit, OnDestroy } from '@angular/core';
import { toast } from 'angular2-materialize';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

import { WarehouseService, Warehouse } from '../../services/warehouse.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { ProductVntaService } from '../../services/product-vnta.service';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Globals } from '../../globals';

@Component({
  selector: 'app-stock-minimal',
  templateUrl: './stock-minimal.component.html',
  styleUrls: ['./stock-minimal.component.css']
})
export class StockMinimalComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  
  unfilteredWarehouses: any[] = [];
  warehouses: any[] = [];
  unfilteredProducts: any[] = [];
  products: any[] = [];
  rows: any[] = [];

  filterProduct: string = '';
  filterWarehouse: string = '';

  warehousesSub: Subscription;

  constructor(
    private warehouseService: WarehouseService,
    private productCmpaService: ProductCmpaService,
    private productVntaService: ProductVntaService,
    private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
      permissionsSubs.unsubscribe();
      this.permission = {
        ...this.permissionService.constructPermissionObject(groups, 'stockPiece'),
        rdc: this.permissionService.constructPermissionObject(groups, Globals.PURCHASE_REQUEST_COLLECTION)
      };
      if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
      else this.allowed = true;
  });
    
    this.warehousesSub = this.warehouseService.getWarehouses().subscribe(warehouses => {
      this.unfilteredWarehouses = warehouses.map(warehouse => {
        warehouse.productsObj = warehouse.products.reduce( (acc, cur) => {
          acc[cur.ref.id] = cur.quantity;
          return acc;
        } , {});
        return warehouse;
      });
      this.unfilteredWarehouses.map((warehouse: Warehouse) => {
        warehouse.products.map(product => {
          if(!this.unfilteredProducts.some(({ref: {id}}) => product.ref.id == id)) this.unfilteredProducts.push({...product});
        });
      });
      if(!this.unfilteredProducts.length){
        this.applyFilter();
        toast('No hay productos en almacenes.', 4000);
      }
      let nameArrived = this.unfilteredProducts.map(a => false);
      this.unfilteredProducts.map((product, index) => {
        let doc = productVntaService.getPrVnta(product.ref.id, product.ref.parent.id );
        let sub = doc.subscribe( ([{reorderQuantity: rq, characs:chs=[], ...pr}]) => {
          sub.unsubscribe();
          let characs = chs.reduce((acc, cur, index) => `${acc}${index ? ', ' : ''}${cur.name.charAt(0)} ${cur.value}`, '');
          this.unfilteredProducts[index].name = `${pr.name}${characs ? ' - ' : ''}${characs}`.trim();
          this.unfilteredProducts[index].class = `${pr.data.name} - ${product.ref.path.split('/')[2] == 'prCmpa' ? 'Compra' : 'Venta'}`;
          this.unfilteredProducts[index].rt = rq;
          nameArrived[index] = true;
          if(!nameArrived.includes(false)) this.applyFilter();
        });
      });
    });
    
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.warehousesSub.unsubscribe();
  }

  applyFilter(warehouse: string = this.filterWarehouse){
    this.filterWarehouse = warehouse;
    this.products = this.unfilteredProducts.filter(({name, class: clas}) => `${clas} ${name}`.toLowerCase().includes(this.filterProduct.toLowerCase()) );
    this.warehouses = this.unfilteredWarehouses.filter(({name}) => !this.filterWarehouse || this.filterWarehouse == name);
    this.rows = this.products.map(p => ({o: false, t: this.warehouses.reduce((acc, {productsObj}) => acc + (productsObj[p.ref.id] || 0), 0), ...p}) ).filter(({t, rt})=>!isNaN(rt) && t < rt);
  }

  onOrder(){
    if(!this.permission.rdc.createAction) return toast('No tiene permiso para crear requisisión de compra.', 2000);
    let obj = {
      odp: '',
      prs: this.rows.filter(({o}) => o).map(({name, t, rt}) => ({name, quantity: rt - t}) )
    }
    localStorage.odpAuto = JSON.stringify(obj);
    this.router.navigate(['/add_purchase_request']);
  }

}
